import { inject } from '@angular/core';
import {
  CanActivateChildFn,
  CanActivateFn,
  GuardResult,
  Router,
} from '@angular/router';

import { AuthService } from '@app/services/auth.service';
import { EnrolStoreService } from '@app/services/enrol-store.service';

function guardRoute() {
  const authService = inject(AuthService);
  const enrolStoreService = inject(EnrolStoreService);
  const router = inject(Router);

  return new Promise<GuardResult>((res) => {
    authService.init$.subscribe({
      error: () => {
        res(false);
      },
      next: (init) => {
        if (!init) return;
        let result: GuardResult = true;
        if (!authService.getUser().courseId) {
          // TODO Move to EnrolComponent?
          const enrol = enrolStoreService.enrol();
          let step = 1;
          if (enrol.nativeLocale) step = 2;
          if (enrol.course) step = 3;
          if (enrol.cohort) step = 4;
          result = router.createUrlTree(['/enrol', step]);
        }
        res(result);
      },
    });
  });
}

export const enrolGuard: CanActivateFn = guardRoute;
export const enrolGuardChild: CanActivateChildFn = guardRoute;
